import { useEffect, useMemo } from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { useStore, useStoreActions } from "../../contexts";
import styles from "./ActivityLogItem.module.scss";
import { timeModel } from "../../models";
import { getContent, getIcon } from "./ActivityLogItem.utils";
import { selectors } from "../../store/state-selectors";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ActivityLogItem(props) {
  const {
    entry,
    vendorName,
    clientName,
    relationship,
    isFirst,
    isLast,
    variant = 'default'
  } = props;
  const {
    logBI
  } = useStoreActions();
  const isVendor = useStore(selectors.user.isVendor);
  const featureFlags = useFeatureFlags();
  const testid = "activity-log-".concat(entry.id());
  const content = useMemo(() => {
    return getContent({
      entry,
      vendorName,
      clientName,
      isVendor,
      relationship,
      testid,
      logBI,
      featureFlags
    });
  }, [entry, vendorName, clientName, relationship, testid, isVendor, featureFlags]);
  useEffect(() => {
    if (!content) {
      // eslint-disable-next-line no-console
      console.warn('Unrecognized activity-log entry', entry);
    }
  }, [content, entry]);
  return content ? /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.date,
      children: /*#__PURE__*/_jsx(Typography, {
        children: timeModel.formatDateWithTime(entry.timestamp())
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.separator,
      children: [/*#__PURE__*/_jsx("div", {
        className: cn(styles.line, {
          [styles.transparent]: isFirst
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.dot
      }), /*#__PURE__*/_jsx("div", {
        className: cn(styles.line, {
          [styles.transparent]: isLast
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: cn(styles.card, variant === 'transparent' && styles.transparent),
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.icon,
        children: getIcon(entry)
      }), /*#__PURE__*/_jsx(Typography, {
        className: styles.content,
        "data-testid": testid,
        children: content
      })]
    })]
  }) : null;
}